import { ChevronDown, ImageOff, Pause, Play } from "lucide-react";
import { useState } from "react";

import { urlImagem } from "../api";
import { Selo } from "./tons";

function Anuncio({ anuncio, podeGerir, encerrada, ocupada, onPausar, onRetomar }) {
  return (
    <li className="flex items-start gap-3 py-2" data-e2e="cartao-anuncio">
      {anuncio.imagem
        ? <img src={urlImagem(anuncio.imagem)} alt="" loading="lazy" className="w-12 h-12 rounded-lg object-cover border bg-muted shrink-0" />
        : <span className="w-12 h-12 rounded-lg border bg-muted flex items-center justify-center shrink-0"><ImageOff className="w-4 h-4 text-muted-foreground" /></span>}
      <div className="min-w-0 flex-1">
        <div className="flex flex-wrap items-center gap-2">
          <span className="text-sm font-medium truncate">{anuncio.titulo || "Anúncio"}</span>
          <Selo situacao={anuncio.situacao} e2e="cartao-anuncio-situacao" />
        </div>
        {anuncio.texto && <p className="text-xs text-muted-foreground line-clamp-2">{anuncio.texto}</p>}
        {anuncio.situacao.codigo === "reprovado" && anuncio.motivo_reprovacao && (
          <p className="text-xs text-red-500 mt-0.5">Motivo: {anuncio.motivo_reprovacao}</p>
        )}
      </div>
      {podeGerir && !encerrada && (
        <button type="button" disabled={ocupada} onClick={anuncio.pausado ? onRetomar : onPausar} data-e2e={anuncio.pausado ? "anuncio-retomar" : "anuncio-pausar"}
          title={anuncio.pausado ? "Retomar este anúncio" : "Pausar só este anúncio"}
          className="h-8 w-8 rounded-lg border flex items-center justify-center hover:border-primary disabled:opacity-50 shrink-0">
          {anuncio.pausado ? <Play className="w-3.5 h-3.5" /> : <Pause className="w-3.5 h-3.5" />}
        </button>
      )}
    </li>
  );
}

/** Os anúncios de uma campanha (até 3), recolhidos por padrão quando há só um. */
export default function AnunciosDoCartao({ campanha, podeGerir, ocupada, acoes }) {
  const anuncios = campanha.anuncios || [];
  const [aberto, setAberto] = useState(anuncios.length > 1 || anuncios.some((a) => a.situacao.codigo === "reprovado"));
  if (anuncios.length === 0) return null;
  const id = campanha.meta_campaign_id;
  return (
    <div className="border-t pt-2">
      <button type="button" onClick={() => setAberto(!aberto)} data-e2e="cartao-ver-anuncios"
        className="flex items-center gap-1 text-xs font-semibold uppercase tracking-wide text-muted-foreground hover:text-foreground">
        <ChevronDown className={`w-3.5 h-3.5 transition-transform ${aberto ? "rotate-180" : ""}`} />
        {anuncios.length === 1 ? "1 anúncio" : `${anuncios.length} anúncios`}
      </button>
      {aberto && (
        <ul className="divide-y divide-border/60 mt-1">
          {anuncios.map((a) => (
            <Anuncio key={a.meta_ad_id} anuncio={a} podeGerir={podeGerir} encerrada={campanha.situacao.codigo === "encerrada"} ocupada={ocupada}
              onPausar={() => acoes.pausarAnuncio(id, a.meta_ad_id)} onRetomar={() => acoes.retomarAnuncio(id, a.meta_ad_id)} />
          ))}
        </ul>
      )}
    </div>
  );
}
